import { contactFormApi, mediaApi } from "../apis/apis"
import queryString from "query-string"

export const isBrowser = typeof window !== "undefined"

export const catchAsync = (fn, fnName = "anonymous function") => {
  return async (...props) => {
    return await fn(...props)
      .then(res => {
        if (res?.status === "error" || res?.data?.error) {
          throw new Error(res?.message)
        }
        return res
      })
      .catch(err => {
        const msg = err.response?.data?.message ?? err.message
        console.error(fnName, msg)
        return {
          status: "error",
          message: msg,
        }
      })
  }
}

export const getLocalStorageItem = key => {
  if (isBrowser) {
    return window.localStorage.getItem(key)
  }
  return null
}

export const setLocalStorageItem = (key, value) => {
  if (isBrowser) {
    window.localStorage.setItem(key, value)
  }
}

export const getColor = (color, theme) => {
  switch (color) {
    case "primary":
      return theme.palette.primary.main
    case "secondary":
      return theme.palette.secondary.main
    case "tertiary":
      return theme.palette.tertiary.main
    case "content":
      return theme.palette.text.content
    default:
      return theme.palette.text.primary
  }
}

export const textEllipsis = (
  str,
  maxLength,
  { side = "end", ellipsis = "..." } = {},
) => {
  if (str.length > maxLength) {
    switch (side) {
      case "start":
        return ellipsis + str.slice(-(maxLength - ellipsis.length))
      case "end":
      default:
        return str.slice(0, maxLength - ellipsis.length) + ellipsis
    }
  }
  return str
}

export const capitalizeFirstLetter = string => {
  if (!string) return
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getRHFErrorMessage = (errors, name, rules) => {
  const splitName = `${name}`.split(".")

  let nameLabel = name
  const getError = () => {
    if (splitName.length === 2) {
      nameLabel = splitName[1]
      return errors[splitName[0]]?.[splitName[1]]
    }
    if (splitName.length === 3) {
      nameLabel = splitName[2]
      return errors[splitName[0]]?.[splitName[1]]?.[splitName[2]]
    }
    return errors[name]
  }
  const error = getError()

  nameLabel = capitalizeFirstLetter(nameLabel)

  if (error) {
    // console.log(name, error);
    if (error?.message) {
      return error.message
    }
    switch (error.type) {
      case "valueAsNumber":
        return `${nameLabel} is not a valid number`
      case "required":
        return "This is a required field"
      case "min":
        return `Min ${rules?.min}`
      case "max":
        return `Max ${rules?.max}`
      case "maxLength":
        return `Max ${rules?.maxLength} characters`
      case "minLength":
        return `Min ${rules?.minLength} characters`
      case "pattern":
        return `${nameLabel} is not valid`
      case "validate":
        //console.log(errors)
        return error.message
      default:
        return ""
    }
  }
}

export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const submitContactForm = catchAsync(async (formId, formData) => {
  const res = await contactFormApi.post(`/${formId}/feedback`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  // console.log("processOrder: ", res.data);
  return res.data
}, "submitContactForm")
export const getWordpressToken = async () => {
  try {
    const response = await mediaApi.post(
      "/jwt-auth/v1/token",
      queryString.stringify({
        username: process.env.GATSBY_USER,
        password: process.env.GATSBY_PASSWORD,
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    const {
      data: { token },
    } = response
    return token
  } catch (error) {
    return null
  }
}
export const uploadFile = async (file, token) => {
  try {
    const response = await mediaApi.post(
      `/wp/v2/media`,
      { file },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          "Content-Disposition": `form-data; filename="${file.name}"`,
        },
      },
    )

    if (response.data.source_url) {
      return { success: response.data, source_url: response.data.source_url }
    }

    return { error: "Something went wrong, please try again" }
  } catch (error) {
    return { error: "Something went wrong, please try again" }
  }
}
